import React,{ useState} from 'react';
import './LoginPage.css';
import {Link , useHistory } from 'react-router-dom';
import {auth} from './firebase';
export default function LoginPage(){
 
 const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const signIn = e => {
        e.preventDefault();

        auth.signInWithEmailAndPassword(email, password)
            .then(auth => {
                history.push('/')
            })
            .catch(error => alert(error.message))
    }

    const register = e => {
        e.preventDefault();

        auth.createUserWithEmailAndPassword(email, password)
            .then((auth) => {
                // it successfully created a new user with email and password
                if (auth) {
                    history.push('/')
                }
            })
            .catch(error => alert(error.message))
    }


  return(
    <div className="login">

    <Link to="/">
    <img  className="login_logo" src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png" alt="logo"/>
    </Link>

    <div className="login_container">
       <h1>Sign-In</h1>

      <form action="">

        <h5>E-mail</h5>
        <input type="email" value={email} onChange={event => setEmail(event.target.value)}/>

        <h5>Password</h5>
        <input type="password" value={password} onChange={event => setPassword(event.target.value)}/>

      <button onClick={signIn} className="signIn_btn">Sign In</button>

      </form>

       <p>
       By signing-in you agree to the  Amazon Clone Conditions of use & Sale, Please see our Privacy Notice, our Cookies Notice and our Interest-Based Ad Notice
        </p>
      <button onClick={register} className="register_btn">Create an Account</button>


    </div>

    
    </div>

  )
}
